import {useEffect, useState} from "react";
import {CircularProgressbar} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import {absentsInterface} from "./absents";
import {CurrencyFormat} from "../../../components/techaran/money";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {CheckIcon, SearchIcon, ThinCloseIcon} from "../../../components/icons/material-icons";

export const AdminsSMSAbsentsModal = (props: { active: boolean, closeHandler: any, list: absentsInterface[] }) => {
    const [list, setList] = useState([] as absentsInterface[]);
    useEffect(() => {
        const isActive = props.active;
        const _list = [...props.list];
        if (isActive) {
            document.body.classList.add('body-no-scroll');
            setSending({
                isSending: false,
                totalSMS: 0,
                totalSent: 0,
                percentSent: 0,
            });
            setList(_list);
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active]);
    const getCountOfSMS = () => {
        const _list = [...list];
        let c = 0;
        _list.map(e => {
            if (e.send)
                c++;
        })
        return CurrencyFormat(c);
    };
    const [sending, setSending] = useState({
        isSending: false,
        totalSMS: 0,
        totalSent: 0,
        percentSent: 0,
    });
    const sendSMS = async () => {
        const oldList = [...list];
        let finalListOfTells = [] as string[];
        oldList.forEach(e => {
            if (e.send)
                finalListOfTells.push(e.tell);
        });
        if (finalListOfTells.length < 1) {
            props.closeHandler();
            return;
        }
        setSending({
            isSending: true,
            percentSent: 0,
            totalSMS: finalListOfTells.length,
            totalSent: 0,
        });
        PostJSON(
            Apis.server + '/core/admins/attend/absents/sms',
            {data: JSON.stringify(finalListOfTells)},
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar('پیامک‌ها با موفقیت ارسال شد.','باشه',5000);
                props.closeHandler();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const isAllChecked = () => {
        const lst = [...list];
        let isAllChecked = true;
        lst.forEach(e => {
            if (!e.send)
                isAllChecked = false;
        });
        return isAllChecked;
    };
    const [search, setSearch] = useState('');
    useEffect(() => {
        const _sending = {...sending};
        const isSending = _sending.isSending;
        if (isSending)
            return;
        const filter = search.toUpperCase();
        const btns = document.querySelectorAll('.attend-sms-absent-checks') as NodeListOf<HTMLButtonElement>;
        // const btns = (lst as HTMLDivElement).getElementsByTagName('button');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('span')[0];
            const v = b.innerHTML.toUpperCase();
            if (v.indexOf(filter) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search, sending]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div>
                        <b>ارسال پیامک غایبین</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    {
                        sending.isSending ?
                            <>
                                <div style={{
                                    padding: 20,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <CircularProgressbar
                                        value={sending.percentSent}
                                        className={"d-inline-block"}
                                        styles={{
                                            root: {width: 200},
                                            trail: {
                                                stroke: '#e1e1e1',
                                            },
                                            path: {
                                                // Path color
                                                stroke: `#0a53be`,
                                            },
                                            text: {
                                                // Text color
                                                fill: '#0a53be',
                                                // Text size
                                                fontSize: '16px',
                                                fontWeight: 500,
                                                fontFamily: 'var(--font-family-p-en)',
                                            },
                                        }}
                                        text={`${sending.percentSent}%`}
                                    />
                                </div>
                                <div className="absents--sms--info">
                                    <b>در حال ارسال پیامک</b>
                                    <span>تاکنون {CurrencyFormat(sending.totalSent)} پیامک ارسال شده است.</span>
                                </div>
                            </> :
                            <>
                                <div className="reports--select-employee" style={{paddingBottom: 70}}>
                                    <label className="f-roboto">
                                        انتخاب افراد گیرنده پیامک:
                                    </label>
                                    <div className="pick-device-search">
                                        <button><SearchIcon/></button>
                                        <input type="text"
                                               value={search}
                                               onChange={e => setSearch(e.currentTarget.value)}
                                               onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                               onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                               className="f-roboto" placeholder={"جستجو بر اساس نام..."}
                                        />
                                    </div>
                                    {
                                        list.length > 1 && search === '' ?
                                            <>
                                                <hr/>
                                                <button
                                                    className={"techaran-checkbox" + (isAllChecked() ? ' active' : '')}
                                                    onClick={() => {
                                                        const check = isAllChecked();
                                                        setList(v => {
                                                            let x = [...v];
                                                            x.forEach(e => {
                                                                e.send = !check;
                                                            });
                                                            return x;
                                                        });
                                                    }}>
                                                    <i><CheckIcon/></i>
                                                    <span>همه افراد</span>
                                                </button>
                                                <hr/>
                                            </> : null
                                    }
                                    {
                                        list.map((e, i) =>
                                                <button
                                                    className={"techaran-checkbox attend-sms-absent-checks" + (e.send ? ' active' : '')}
                                                    key={"Kje89wqDkFdFv89" + i}
                                                    onClick={() => setList(v => {
                                                        let x = [...v];
                                                        const ind = x.findIndex(r => r.id === e.id);
                                                        x[ind].send = !x[ind].send;
                                                        return x;
                                                    })}>
                                                    <i><CheckIcon/></i>
                                                    <span>
                                        {e.name}
                                                        <em>ارسال به شماره {e.tell}</em>
                                    </span>
                                                </button>
                                        )
                                    }
                                </div>
                                <div className="calc-action-bottom">
                                    <span className="f-roboto">تعداد پیامک ارسالی: {getCountOfSMS()}</span>
                                    <div>
                                        <button className="calc-action-bottom-cta" onClick={sendSMS}>
                                            <span>ارسال پیامک</span>
                                        </button>
                                    </div>
                                </div>
                            </>
                    }
                </div>
            </div>
        </>
    );
};